"use client";

import type { ReactNode } from "react";
import { createContext, useContext, useState } from "react";
import type { LeftContent } from "~/app/auth/_lib/auth-content";

type AuthLeftContentState = {
  leftContent: LeftContent;
  setLeftContent: (content: LeftContent) => void;
};

const AuthLeftContentContext = createContext<AuthLeftContentState | null>(null);

export function AuthLeftContentProvider({
  initial,
  children,
}: {
  initial: LeftContent;
  children: ReactNode;
}) {
  const [leftContent, setLeftContent] = useState<LeftContent>(initial);
  return (
    <AuthLeftContentContext.Provider value={{ leftContent, setLeftContent }}>
      {children}
    </AuthLeftContentContext.Provider>
  );
}

export function useAuthLeftContent(): AuthLeftContentState {
  const ctx = useContext(AuthLeftContentContext);
  if (!ctx)
    throw new Error(
      "useAuthLeftContent must be used inside AuthLeftContentProvider",
    );
  return ctx;
}
